<template lang="pug">
  aside.newsletter
    .newsletter-wrapper
      h2 {{ settings.newsletter_title }}
      p(v-if="settings.newsletter_description") {{ settings.newsletter_description[0].text }}
      .newsletter-form(v-html="settings.newsletter_signup")
</template>

<script>
export default {
  props: ['settingsData'],
  computed: {
    settings: function () {
      return this.settingsData
    }
  }
}
</script>

<style lang="stylus">
@import '../styles/helpers/variables.styl'
@import '../styles/components/button.styl'

.newsletter
  background-color whitesmoke
  display flex
  justify-content center
  padding 5rem 0 6rem 0
  .newsletter-wrapper
    max-width 88%
    h2
      color gray
      margin-bottom 1.25rem
    p
      margin-bottom 1.5rem
    form
      display flex
      align-items center
      .mc-field-group
        display inline-block
      #mce-EMAIL
        border-radius 5px
        border none
        font-family $font-primary
        font-size 16px
        height 2.6rem
        margin-right 1rem
        max-width 20rem
        padding 0 1rem
        width 100%
      .mce-EMAIL
          display none
  @media (max-width: 421px)
    .newsletter-wrapper > form
      align-items flex-start
      flex-direction column
      input
        margin-bottom 1rem
        width 88%
</style>
